import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Mail,
  MessageSquare,
  Trash2,
  Eye,
  Calendar,
  User,
  Package,
} from "lucide-react";
import { API } from "../api";

export default function AdminMessages() {
  const [view, setView] = useState("messages");
  const [messages, setMessages] = useState([]);
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (view === "messages") {
          const res = await API.get("/contact/all");
          setMessages(res.data);
        } else {
          const res = await API.get("/api/conv/all");
          setConversations(res.data);
        }
      } catch (err) {
        console.error("Erreur de récupération :", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [view]);

  const deleteMessage = async (id) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce message ?"))
      return;
    try {
      await API.delete(`/contact/delete/${id}`);
      setMessages(messages.filter((m) => m.id_contact !== id));
      setShowModal(false);
    } catch (err) {
      console.error("Erreur de suppression :", err);
    }
  };

  const deleteConversation = async (id) => {
    if (
      !window.confirm("Êtes-vous sûr de vouloir supprimer cette conversation ?")
    )
      return;
    try {
      await API.delete(`/conversation/delete/${id}`);
      setConversations(conversations.filter((c) => c.id_conv !== id));
      setShowModal(false);
    } catch (err) {
      console.error("Erreur de suppression :", err);
    }
  };

  const openModal = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  return (
    <div
      className="container-fluid py-4"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body text-center py-4">
              <h1
                className="mb-3"
                style={{ color: "#2c3e50", fontWeight: "700" }}
              >
                <Mail
                  className="me-2"
                  size={32}
                  style={{ verticalAlign: "middle" }}
                />
                Gestion des Communications
              </h1>
              <p className="text-muted mb-0">
                Gérez les messages de contact et les conversations produits
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Pills */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-center gap-3">
            <button
              onClick={() => setView("messages")}
              className={`btn btn-lg px-4 py-3 d-flex align-items-center gap-2 ${
                view === "messages"
                  ? "btn-primary shadow"
                  : "btn-outline-primary"
              }`}
              style={{ borderRadius: "12px", fontWeight: "600" }}
            >
              <Mail size={20} />
              Messages de Contact
              <span className="badge bg-light text-dark ms-2">
                {messages.length}
              </span>
            </button>
            <button
              onClick={() => setView("conversations")}
              className={`btn btn-lg px-4 py-3 d-flex align-items-center gap-2 ${
                view === "conversations"
                  ? "btn-primary shadow"
                  : "btn-outline-primary"
              }`}
              style={{ borderRadius: "12px", fontWeight: "600" }}
            >
              <MessageSquare size={20} />
              Conversations Produits
              <span className="badge bg-light text-dark ms-2">
                {conversations.length}
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      {loading ? (
        <div className="text-center py-5">
          <div
            className="spinner-border text-primary"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="visually-hidden">Chargement...</span>
          </div>
          <p className="mt-3 text-muted">Chargement des données...</p>
        </div>
      ) : (
        <>
          {view === "messages" ? (
            <div className="row">
              <div className="col-12">
                <div className="card border-0 shadow-sm">
                  <div className="card-header bg-white border-0 py-3">
                    <h4
                      className="mb-0 d-flex align-items-center"
                      style={{ color: "#2c3e50" }}
                    >
                      <Mail className="me-2" size={24} />
                      Messages Reçus
                    </h4>
                  </div>
                  <div className="card-body p-0">
                    {messages.length === 0 ? (
                      <div className="text-center py-5">
                        <Mail size={48} className="text-muted mb-3" />
                        <p className="text-muted">
                          Aucun message reçu pour le moment
                        </p>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-hover mb-0">
                          <thead style={{ backgroundColor: "#f8f9fa" }}>
                            <tr>
                              <th className="border-0 py-3">
                                <User size={16} className="me-2" />
                                Expéditeur
                              </th>
                              <th className="border-0 py-3">
                                <Mail size={16} className="me-2" />
                                Email
                              </th>
                              <th className="border-0 py-3">Sujet</th>
                              <th className="border-0 py-3">Aperçu</th>
                              <th className="border-0 py-3">
                                <Calendar size={16} className="me-2" />
                                Date
                              </th>
                              <th className="border-0 py-3 text-center">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {messages.map((m) => (
                              <tr
                                key={m.id_contact}
                                style={{ cursor: "pointer" }}
                              >
                                <td className="align-middle">
                                  <div className="d-flex align-items-center">
                                    <div
                                      className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-2"
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {m.nom?.charAt(0).toUpperCase()}
                                    </div>
                                    <strong>{m.nom}</strong>
                                  </div>
                                </td>
                                <td className="align-middle">
                                  <small className="text-muted">
                                    {m.email}
                                  </small>
                                </td>
                                <td className="align-middle">
                                  <span className="badge bg-info text-dark">
                                    {m.sujet}
                                  </span>
                                </td>
                                <td className="align-middle">
                                  <small className="text-muted">
                                    {m.message?.substring(0, 50)}
                                    {m.message?.length > 50 ? "..." : ""}
                                  </small>
                                </td>
                                <td className="align-middle">
                                  <small>
                                    {new Date(m.createdAt).toLocaleDateString(
                                      "fr-FR"
                                    )}
                                  </small>
                                </td>
                                <td className="align-middle text-center">
                                  <button
                                    onClick={() => openModal(m)}
                                    className="btn btn-sm btn-outline-primary me-2"
                                    title="Voir détails"
                                  >
                                    <Eye size={16} />
                                  </button>
                                  <button
                                    onClick={() => deleteMessage(m.id_contact)}
                                    className="btn btn-sm btn-outline-danger"
                                    title="Supprimer"
                                  >
                                    <Trash2 size={16} />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                <div className="card border-0 shadow-sm">
                  <div className="card-header bg-white border-0 py-3">
                    <h4
                      className="mb-0 d-flex align-items-center"
                      style={{ color: "#2c3e50" }}
                    >
                      <MessageSquare className="me-2" size={24} />
                      Conversations Clients
                    </h4>
                  </div>
                  <div className="card-body p-0">
                    {conversations.length === 0 ? (
                      <div className="text-center py-5">
                        <MessageSquare size={48} className="text-muted mb-3" />
                        <p className="text-muted">
                          Aucune conversation pour le moment
                        </p>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-hover mb-0">
                          <thead style={{ backgroundColor: "#f8f9fa" }}>
                            <tr>
                              <th className="border-0 py-3">
                                <User size={16} className="me-2" />
                                Client
                              </th>
                              <th className="border-0 py-3">
                                <Mail size={16} className="me-2" />
                                Email
                              </th>
                              <th className="border-0 py-3">
                                <Package size={16} className="me-2" />
                                Produit
                              </th>
                              <th className="border-0 py-3">Message</th>
                              <th className="border-0 py-3">
                                <Calendar size={16} className="me-2" />
                                Date
                              </th>
                              <th className="border-0 py-3 text-center">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {conversations.map((c) => (
                              <tr key={c.id_conv} style={{ cursor: "pointer" }}>
                                <td className="align-middle">
                                  <div className="d-flex align-items-center">
                                    <div
                                      className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center me-2"
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {c.Client?.nom?.charAt(0).toUpperCase()}
                                    </div>
                                    <strong>{c.Client?.nom}</strong>
                                  </div>
                                </td>
                                <td className="align-middle">
                                  <small className="text-muted">
                                    {c.Client?.email}
                                  </small>
                                </td>
                                <td className="align-middle">
                                  <span className="badge bg-warning text-dark">
                                    {c.Article?.nom}
                                  </span>
                                </td>
                                <td className="align-middle">
                                  <small className="text-muted">
                                    {c.message?.substring(0, 50)}
                                    {c.message?.length > 50 ? "..." : ""}
                                  </small>
                                </td>
                                <td className="align-middle">
                                  <small>
                                    {new Date(c.createdAt).toLocaleDateString(
                                      "fr-FR"
                                    )}
                                  </small>
                                </td>
                                <td className="align-middle text-center">
                                  <button
                                    onClick={() => openModal(c)}
                                    className="btn btn-sm btn-outline-primary me-2"
                                    title="Voir détails"
                                  >
                                    <Eye size={16} />
                                  </button>
                                  <button
                                    onClick={() =>
                                      deleteConversation(c.id_conv)
                                    }
                                    className="btn btn-sm btn-outline-danger"
                                    title="Supprimer"
                                  >
                                    <Trash2 size={16} />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {/* Modal */}
      {showModal && selectedItem && (
        <>
          <div
            className="modal show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            onClick={closeModal}
          >
            <div
              className="modal-dialog modal-dialog-centered modal-lg"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content border-0 shadow-lg">
                <div className="modal-header border-0 pb-0">
                  <h5 className="modal-title d-flex align-items-center">
                    {view === "messages" ? (
                      <>
                        <Mail className="me-2" size={24} />
                        Détails du Message
                      </>
                    ) : (
                      <>
                        <MessageSquare className="me-2" size={24} />
                        Détails de la Conversation
                      </>
                    )}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body">
                  {view === "messages" ? (
                    <div>
                      <div className="mb-3">
                        <label className="form-label fw-bold">
                          <User size={16} className="me-2" />
                          Nom
                        </label>
                        <p className="form-control-plaintext border rounded p-2 bg-light">
                          {selectedItem.nom}
                        </p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label fw-bold">
                          <Mail size={16} className="me-2" />
                          Email
                        </label>
                        <p className="form-control-plaintext border rounded p-2 bg-light">
                          {selectedItem.email}
                        </p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label fw-bold">Sujet</label>
                        <p className="form-control-plaintext border rounded p-2 bg-light">
                          {selectedItem.sujet}
                        </p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label fw-bold">Message</label>
                        <p
                          className="form-control-plaintext border rounded p-3 bg-light"
                          style={{ minHeight: "100px" }}
                        >
                          {selectedItem.message}
                        </p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label fw-bold">
                          <Calendar size={16} className="me-2" />
                          Date de réception
                        </label>
                        <p className="form-control-plaintext border rounded p-2 bg-light">
                          {new Date(selectedItem.createdAt).toLocaleString(
                            "fr-FR"
                          )}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="mb-3">
                        <label className="form-label fw-bold">
                          <User size={16} className="me-2" />
                          Client
                        </label>
                        <p className="form-control-plaintext border rounded p-2 bg-light">
                          {selectedItem.Client?.nom}
                        </p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label fw-bold">
                          <Mail size={16} className="me-2" />
                          Email
                        </label>
                        <p className="form-control-plaintext border rounded p-2 bg-light">
                          {selectedItem.Client?.email}
                        </p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label fw-bold">
                          <Package size={16} className="me-2" />
                          Produit concerné
                        </label>
                        <p className="form-control-plaintext border rounded p-2 bg-light">
                          {selectedItem.Article?.nom}
                        </p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label fw-bold">Message</label>
                        <p
                          className="form-control-plaintext border rounded p-3 bg-light"
                          style={{ minHeight: "100px" }}
                        >
                          {selectedItem.message}
                        </p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label fw-bold">
                          <Calendar size={16} className="me-2" />
                          Date de la conversation
                        </label>
                        <p className="form-control-plaintext border rounded p-2 bg-light">
                          {new Date(selectedItem.createdAt).toLocaleString(
                            "fr-FR"
                          )}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
                <div className="modal-footer border-0">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    Fermer
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => {
                      if (view === "messages") {
                        deleteMessage(selectedItem.id_contact);
                      } else {
                        deleteConversation(selectedItem.id_conv);
                      }
                    }}
                  >
                    <Trash2 size={16} className="me-2" />
                    Supprimer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Bootstrap CSS */}
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />
    </div>
  );
}
